import React from 'react';
import {
    SimpleTable,
    MasterLayoutMiddle,
    FooterInner
} from '@dclab/dc-react-ui-kit';

import Edit from "../../../assets/img/create-24px.svg";
import Delete from "../../../assets/img/delete_forever-24px.svg";


function EducationAnnouncements(props) {

    const style = {
        width: '100%',
    };



    // ============================== Table Start ======================================//
    let col = [

        { type: 'link', name: 'invoice_number', label: 'TITLE', width: '30%' },
        { type: 'string', name: 'date', label: 'DETAILS', width: '60%' },
        { type: 'string', name: 'date', label: '', width: '20%' },
        { type: 'action', label: 'ACTION', width: '20%' }

    ];

    const selected_categories = col.sort((a, b) => a.order - b.order)
    let rows = selected_categories.map((text, index) => {
        let i = index + 1
        return (
            [

                { type: 'string', name: 'name', value: 'Ramadan is on our doorstep.' },
                { type: 'status', name: 'string', value: 'It is essential to be in the best of forms, both physically and spiritually..' },
                { type: 'string', name: 'string', value: '' },

            ]
        )
    })


    // ============================== Table End ======================================//

    return (

        <div className="table_box">
            <SimpleTable
                showHeader={true}
                title="Announcements"
                width="100%"
                rows={rows}
                columns={col}
                colSpan={16}
                actionSendButton={true}
                donationsCount={rows && rows.length > 0 ? 1 : 0}
                noTitle="No inquiry submitted yet"
                noPara="Inquiries submitted by visitors will be visible and managed here."
                noBtnText=""
                onInviteClick={() =>
                    props.history.push(
                        "/education/add-new-announcement"
                    )
                }
                actionLink={(name) => props.history.push({ pathname: "/education/add-new-announcement", state: { contact: name[0].data } })}
                deleteAction={(e) => console.log(e)}
                showFooter={true}
                showIconCol={true}
                editIcon={Edit}
                deleteIcon={Delete}
                showAdd={true}
                addText='Add New'

            />
        </div>

    );
}


export default EducationAnnouncements;